// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.MixPlaylist {
  width: auto !important;
  max-width: 33% !important;
  justify-content: center;
  margin: 0 auto;
  margin-top: 10px;
  padding: 0 10px;
  overflow: visible !important;
  user-select: none;
}
.MixPlaylist .percent-slider {
  position: relative;
  margin: 0 auto;
  background: #FFFFFF;
  width: 178px;
  height: 178px;
  border: 1px solid #CCC;
  border-radius: 50%;
}
.MixPlaylist .percent-slider .inner-circle {
  position: absolute;
  top: 15px;
  left: 15px;
  background: #F6F6F6;
  width: 148px;
  height: 148px;
  border-radius: 50%;
}
.MixPlaylist .percent-slider .inner-circle .percentage {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}
.MixPlaylist .percent-slider .active-border {
  position: absolute;
  top: 5px;
  left: 5px;
  text-align: center;
  width: 168px;
  height: 168px;
  border-radius: 50%;
  background-color: #00A474;
  background-image: linear-gradient(91deg, transparent 50%, #FFFFFF 50%), linear-gradient(90deg, #FFFFFF 50%, transparent 50%);
}
.MixPlaylist .percent-slider .active-border-inner {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #FFFFFF;
  width: 158px;
  height: 158px;
  border-radius: 50%;
}
.MixPlaylist .percent-slider .handle-container {
  position: absolute;
  left: 7.5px;
  right: 7.5px;
  top: 50%;
  height: 2px;
  margin-top: -1px;
  transform: rotate(-90deg);
}
.MixPlaylist .percent-slider .handle-container .handle {
  cursor: default;
  position: absolute;
  right: -12px;
  transform: translateY(-50%);
  height: 24px;
  width: 24px;
  border-radius: 100%;
  background: #00A474;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 10px 0;
}
.MixPlaylist .playlist-details {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 25px;
  padding: 0 8px;
  background: #FFFFFF;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  font-size: 12px;
}
.MixPlaylist .playlist-details .playlist-image-container {
  width: 24px;
  height: 24px;
  overflow: hidden;
  border-radius: 4px;
  margin-right: 10px;
}
.MixPlaylist .playlist-details .playlist-image-container .playlist-image {
  width: 24px;
  min-height: 24px;
}
.MixPlaylist .playlist-details .playlist-name {
  flex-grow: 1;
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
}
.MixPlaylist .playlist-details .remove-playlist {
  margin-left: 5px;
  text-align: right;
}
.MixPlaylist .playlist-details .remove-playlist .remove-playlist-icon {
  font-size: 16px;
  color: #959AAD;
}
.MixPlaylist .playlist-details .remove-playlist .remove-playlist-icon:hover {
  cursor: pointer;
}
.MixPlaylist .lock-container {
  margin: 25px 0;
  text-align: center;
}
.MixPlaylist .lock-container .lock-status {
  background: #FFFFFF;
  opacity: 0.5;
  border-radius: 50%;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  padding: 8px 16px;
}
.MixPlaylist .lock-container .lock-status .lock-icon {
  font-size: 16px;
}
.MixPlaylist .lock-container .lock-status:hover {
  cursor: pointer;
  background: rgba(0, 164, 116, 0.16);
}
.MixPlaylist .lock-container .lock-status.locked {
  background: #00A474;
  opacity: 1;
}
.MixPlaylist .lock-container .lock-status.locked .lock-icon {
  color: #FFFFFF;
}
.MixPlaylist .lock-container .lock-status.locked:hover {
  background: #00A474;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/vibeguide/src/components/MixPlaylist/MixPlaylist.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACEA;EACE,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,iBAAA;AAuFF;AArFE;EACE,kBAAA;EACA,cAAA;EACA,mBDOI;ECNJ,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAuFJ;AArFI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBDdM;ECeN,YAAA;EACA,aAAA;EACA,kBAAA;AAuFN;AArFM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAuFR;AAnFI;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBDjCI;ECkCJ,4HACE;AAmFR;AA/EI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBDtCE;ECuCF,YAAA;EACA,aAAA;EACA,kBAAA;AAiFN;AA9EI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EAEA,yBAAA;AA+EN;AA7EM;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBDnEE;ECoEF,2CAAA;AA+ER;AA1EE;EACE,aAAA;EACA,mBAAA;EAEA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,mBD3EI;EC4EJ,4CAAA;EACA,kBAAA;EACA,eAAA;AA2EJ;AAzEI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA2EN;AAzEM;EACE,WAAA;EACA,gBAAA;AA2ER;AAvEI;EACE,YAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAyEN;AAtEI;EACE,gBAAA;EACA,iBAAA;AAwEN;AAtEM;EACE,eAAA;EACA,cDrHE;AC6LV;AAtEQ;EACE,eAAA;AAwEV;AAlEE;EACE,cAAA;EACA,kBAAA;AAoEJ;AAlEI;EACE,mBD1HE;EC2HF,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,iBAAA;AAoEN;AAlEM;EACE,eAAA;AAoER;AAjEM;EACE,eAAA;EACA,mCDxFI;AC2JZ;AAhEM;EACE,mBD/IE;ECgJF,UAAA;AAkER;AAhEQ;EACE,cD9IF;ACgNR;AA/DQ;EACE,mBDvJA;ACwNV","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '../../sass/color.scss' as color;\n\n.MixPlaylist {\n  width: auto !important;\n  max-width: 33% !important;\n  justify-content: center;\n  margin: 0 auto;\n  margin-top: 10px;\n  padding: 0 10px;\n  overflow: visible!important;\n  user-select: none;\n\n  .percent-slider {\n    position: relative;\n    margin: 0 auto;\n    background: color.$white;\n    width: 178px;\n    height: 178px;\n    border: 1px solid #CCC;\n    border-radius: 50%;\n\n    .inner-circle {\n      position: absolute;\n      top: 15px;\n      left: 15px;\n      background: color.$lightGray;\n      width: 148px;\n      height: 148px;\n      border-radius: 50%;\n      // box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.16);\n      .percentage {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        text-align: center;\n        font-size: 24px;\n        font-weight: bold;\n      }\n    }\n\n    .active-border {\n      // transform: rotate(90deg);\n      position: absolute;\n      top: 5px;\n      left: 5px;\n      text-align: center;\n      width: 168px;\n      height: 168px;\n      border-radius: 50%;\n      background-color: color.$success;\n      background-image:\n        linear-gradient(91deg, transparent 50%, color.$white 50%),\n        linear-gradient(90deg, color.$white 50%, transparent 50%);\n    }\n\n    .active-border-inner {\n      position: absolute;\n      top: 10px;\n      left: 10px;\n      background: color.$white;\n      width: 158px;\n      height: 158px;\n      border-radius: 50%;\n    }\n\n    .handle-container {\n      position: absolute;\n      left: 7.5px;\n      right: 7.5px;\n      top: 50%;\n      height: 2px;\n      margin-top: -1px;\n      // Handle starting position at the top\n      transform: rotate(-90deg);\n\n      .handle {\n        cursor: default;\n        position: absolute;\n        right: -12px;\n        transform: translateY(-50%);\n        height: 24px;\n        width: 24px;\n        border-radius: 100%;\n        background: color.$success;\n        box-shadow: rgba(0, 0, 0, 0.3) 0 1px 10px 0;\n      }\n    }\n  }\n\n  .playlist-details {\n    display: flex;\n    align-items: center;\n    // width: 100%;\n    height: 40px;\n    margin-bottom: 25px;\n    padding: 0 8px;\n    background: color.$white;\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);\n    border-radius: 4px;\n    font-size: 12px;\n\n    .playlist-image-container {\n      width: 24px;\n      height: 24px;\n      overflow: hidden;\n      border-radius: 4px;\n      margin-right: 10px;\n\n      .playlist-image {\n        width: 24px;\n        min-height: 24px;\n      }\n    }\n\n    .playlist-name {\n      flex-grow: 1;\n      width: 50%;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      font-weight: bold;\n    }\n\n    .remove-playlist {\n      margin-left: 5px;\n      text-align: right;\n\n      .remove-playlist-icon {\n        font-size: 16px;\n        color: color.$manatee;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  .lock-container {\n    margin: 25px 0;\n    text-align: center;\n\n    .lock-status {\n      background: color.$white;\n      opacity: 0.5;\n      border-radius: 50%;\n      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);\n      padding: 8px 16px;\n\n      .lock-icon {\n        font-size: 16px;\n      }\n\n      &:hover {\n        cursor: pointer;\n        background: color.$success16;\n      }\n\n      &.locked {\n        background: color.$success;\n        opacity: 1;\n\n        .lock-icon {\n          color: color.$white;\n        }\n\n        &:hover {\n          background: color.$success;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
